import _ from 'underscore';
import $ from 'jquery';
import { getStorage } from '../../../home24/helpers/storage-factory';
import * as baseTracking from '../../../home24-shared/core/base-tracking';
import * as registry from '../../../home24/core/registry';

/**
 * tracking for login/register, but only if part of checkout process
 */
export default function LoginEvents(options) {
    this.$el = options.$el;
    this.initialize();
}

LoginEvents.prototype = _.extend({}, baseTracking, {

    cookieCallbacks: {
        GtmOnLoginClicked: 'afterLoginClicked',
        GtmOnRegisterClicked: 'afterRegisterClicked'
    },

    initialize: function () {
        this.$el.find('.js-login-form').on('submit', $.proxy(this.onLoginFormSubmit, this));
        this.$el.find('.js-register-form-private, .js-register-form-business').on('submit', $.proxy(this.onRegisterFormSubmit, this));
    },

    isInCheckout: function () {
        return registry.get('currentLayout') === 'checkout';
    },

    onLoginFormSubmit: function () {
        if (this.isInCheckout()) {
            getStorage().set('GtmOnLoginClicked', 1);
        }
    },

    onRegisterFormSubmit: function () {
        if (this.isInCheckout()) {
            getStorage().set('GtmOnRegisterClicked', 1);
        }
    },

    afterLoginClicked: function () {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'checkoutOption',
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 1,
                            option: 'login'
                        }
                    }
                }
            });
        }
    },

    afterRegisterClicked: function () {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'checkoutOption',
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 1,
                            option: 'register'
                        }
                    }
                }
            });
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/checkout/LoginEvents.js
 **/